// extracted by mini-css-extract-plugin
export default {"root":"TableHeadTip_root__eXQGO","content":"TableHeadTip_content__JDJZn","percent":"TableHeadTip_percent__BBql5"};